// export const API_URL = "http://192.168.1.106:5238";
export const API_URL = "https://api.teknokarne.net";
// export const API_URL = "http://localhost:5238";
